import { render, staticRenderFns } from "./cabinet-fl223-notice-card-delete-button.vue?vue&type=template&id=798661cf&"
import script from "./cabinet-fl223-notice-card-delete-button.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl223-notice-card-delete-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798661cf')) {
      api.createRecord('798661cf', component.options)
    } else {
      api.reload('798661cf', component.options)
    }
    module.hot.accept("./cabinet-fl223-notice-card-delete-button.vue?vue&type=template&id=798661cf&", function () {
      api.rerender('798661cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl223/cards/partials/cabinet-fl223-notice-card-delete-button.vue"
export default component.exports